<template>
  <!-- BEGIN: Top Bar -->
  <div
    class="
      top-bar-boxed
      border-b border-theme-2
      -mt-7
      md:-mt-5
      -mx-3
      sm:-mx-8
      px-3
      sm:px-8
      md:pt-0
      mb-12
    "
  >
    <div class="h-full flex items-center">
      <!-- BEGIN: Logo -->
      <router-link tag="a" to="/" class="-intro-x hidden md:flex">
        <img
          alt="Icewall Tailwind HTML Admin Template"
          class="w-6"
          src="@/assets/images/simplelogo.png"
        />
        <span class="text-white text-lg ml-3">
          <span class="font-medium">Asistomedia</span>
        </span>
      </router-link>
      <!-- END: Logo -->
      <!-- BEGIN: Notifications -->
      <div v-if="false" class="intro-x dropdown mr-4 sm:mr-6">
        <div
          class="
            dropdown-toggle
            notification notification--bullet
            cursor-pointer
          "
          role="button"
          aria-expanded="false"
        >
          <BellIcon class="notification__icon dark:text-gray-300" />
        </div>
        <div class="notification-content pt-2 dropdown-menu">
          <div
            class="
              notification-content__box
              dropdown-menu__content
              box
              dark:bg-dark-6
            "
          >
            <div class="notification-content__title">Notifications</div>
            <div
              v-for="(faker, fakerKey) in $_.take($f(), 5)"
              :key="fakerKey"
              class="cursor-pointer relative flex items-center"
              :class="{ 'mt-5': fakerKey }"
            >
              <div class="w-12 h-12 flex-none image-fit mr-1">
                <img
                  alt="Icewall Tailwind HTML Admin Template"
                  class="rounded-full"
                  :src="require(`@/assets/images/${faker.photos[0]}`).default"
                />
                <div
                  class="
                    w-3
                    h-3
                    bg-theme-10
                    absolute
                    right-0
                    bottom-0
                    rounded-full
                    border-2 border-white
                  "
                ></div>
              </div>
              <div class="ml-2 overflow-hidden">
                <div class="flex items-center">
                  <a href="javascript:;" class="font-medium truncate mr-5"></a>
                  <div
                    class="text-xs text-gray-500 ml-auto whitespace-nowrap"
                  ></div>
                </div>
                <div class="w-full truncate text-gray-600 mt-0.5"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Notifications -->
      <!-- BEGIN: Account Menu -->
      <div class="intro-x dropdown w-8 h-8 ml-auto">
        <div
          class="
            dropdown-toggle
            w-8
            h-8
            rounded-full
            overflow-hidden
            shadow-lg
            image-fit
            zoom-in
            scale-110
          "
          role="button"
          aria-expanded="false"
        >
          <img
            alt="User photo"
            :src="require(`@/assets/images/user.svg`).default"
          />
        </div>
        <div class="dropdown-menu w-56">
          <div
            class="
              dropdown-menu__content
              box
              bg-theme-11
              dark:bg-dark-6
              text-white
            "
          >
            <div class="p-4 border-b border-theme-12 dark:border-dark-3">
              <div class="font-medium">
                {{ $store.state?.auth?.user?.name }}
                {{ $store.state?.auth?.user?.last_name }}
              </div>
              <div class="text-xs text-theme-28 mt-0.5 dark:text-gray-600">
                {{ $store.state?.auth?.user?.role?.role.toUpperCase() }}
              </div>
            </div>
            <div v-if="false" class="p-2">
              <a
                href=""
                class="
                  flex
                  items-center
                  block
                  p-2
                  transition
                  duration-300
                  ease-in-out
                  hover:bg-theme-1
                  dark:hover:bg-dark-3
                  rounded-md
                "
              >
                <UserIcon class="w-4 h-4 mr-2" /> Profile
              </a>
              <a
                href=""
                class="
                  flex
                  items-center
                  block
                  p-2
                  transition
                  duration-300
                  ease-in-out
                  hover:bg-theme-1
                  dark:hover:bg-dark-3
                  rounded-md
                "
              >
                <EditIcon class="w-4 h-4 mr-2" /> Add Account
              </a>
              <a
                href=""
                class="
                  flex
                  items-center
                  block
                  p-2
                  transition
                  duration-300
                  ease-in-out
                  hover:bg-theme-1
                  dark:hover:bg-dark-3
                  rounded-md
                "
              >
                <LockIcon class="w-4 h-4 mr-2" /> Reset Password
              </a>
              <a
                href=""
                class="
                  flex
                  items-center
                  block
                  p-2
                  transition
                  duration-300
                  ease-in-out
                  hover:bg-theme-1
                  dark:hover:bg-dark-3
                  rounded-md
                "
              >
                <HelpCircleIcon class="w-4 h-4 mr-2" /> Help
              </a>
            </div>
            <div class="p-2 border-t border-theme-12 dark:border-dark-3">
              <a
                href="javascript: void(0)"
                class="
                  flex
                  items-center
                  block
                  p-2
                  transition
                  duration-300
                  ease-in-out
                  hover:bg-theme-1
                  dark:hover:bg-dark-3
                  rounded-md
                "
                @click="logout"
              >
                <ToggleRightIcon class="w-4 h-4 mr-2" /> Cerrar sesión
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- END: Account Menu -->
    </div>
  </div>
  <!-- END: Top Bar -->
</template>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  setup() {
    const searchDropdown = ref(false)

    const showSearchDropdown = () => {
      searchDropdown.value = true
    }

    const hideSearchDropdown = () => {
      searchDropdown.value = false
    }

    return {
      searchDropdown,
      showSearchDropdown,
      hideSearchDropdown
    }
  },
  methods: {
    async logout() {
      cash('body').trigger('click')
      this.$store.commit('main/setShowSpinner', true)
      this.$store.commit('auth/clearData')
      this.$router.push('/login')
      this.$store.commit('main/setShowSpinner', false)
    }
  }
})
</script>
